import React, { useEffect, useState } from 'react';
import './Notification.css';

const Notification = ({ message, type = "info", onClose, show, duration = 3000 }) => {
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (show) {
      setIsFading(false);
      const timer = setTimeout(() => {
        setIsFading(true);
        setTimeout(() => onClose(), 300);
      }, duration); // customizable duration
      
      return () => clearTimeout(timer);
    }
  }, [show, onClose, duration]);

  if (!show) return null;

  return (
    <div className={`notification-container ${type} ${isFading ? 'fade-out' : ''}`}>
      <div className="notification-content">
        <span className="notification-message">{message}</span>
        <button className="notification-close" onClick={() => {
          setIsFading(true);
          setTimeout(() => onClose(), 300);
        }}>
          ×
        </button>
      </div>
    </div>
  );
};

export default Notification;
